var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.225,
    height: 12.225,
    viewBox: "0 0 12.225 12.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin",
    "data-name": "Icon awesome-linkedin",
    d: "M11.351,2.25H.87A.877.877,0,0,0,0,3.131V13.593a.877.877,0,0,0,.87.881H11.351a.879.879,0,0,0,.873-.881V3.131A.879.879,0,0,0,11.351,2.25ZM3.695,12.728H1.883V6.894H3.7v5.834ZM2.789,6.1A1.051,1.051,0,1,1,3.839,5.047,1.051,1.051,0,0,1,2.789,6.1Zm7.7,6.631H8.675V9.89c0-.677-.014-1.547-.941-1.547-.944,0-1.089.737-1.089,1.5v2.887H4.833V6.894H6.571v.8H6.6A1.908,1.908,0,0,1,8.312,6.75c1.834,0,2.175,1.209,2.175,2.781Z",
    transform: "translate(0 -2.25)",
    fill: "#040227"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.0bb57722d3dba5183e6071880ab90bf4.svg";
export { ForwardRef as ReactComponent };